import React from 'react';

// VETT Score Bar - Design guidelines compliant
// Track: height 5px, bg --s3 (#3A3D48), radius 3px
// Fill: gradient coral to light coral
// Score value: DM Mono 500, 11-14px
export const VettScoreBar = ({ score, label, size = 'md' }) => {
  const sizeClasses = {
    sm: {
      track: 'h-1',
      label: 'text-[7px] w-10',
      value: 'text-[10px] w-6'
    },
    md: {
      track: 'h-[5px]',
      label: 'text-[8px] w-12',
      value: 'text-xs w-8'
    },
    lg: {
      track: 'h-1.5',
      label: 'text-[9px] w-14',
      value: 'text-sm w-10'
    }
  };

  const s = sizeClasses[size] || sizeClasses.md;

  return (
    <div className="flex items-center gap-2 sm:gap-3" data-testid="vett-score-bar">
      {label && (
        <span className={`${s.label} font-mono uppercase tracking-[0.12em] text-[#707080]`}>
          {label}
        </span>
      )}
      <div className={`flex-1 ${s.track} bg-[#3A3D48] rounded-full overflow-hidden`}>
        <div 
          className="h-full rounded-full bg-gradient-to-r from-[#E8505A] to-[#F08080] transition-all duration-700 ease-out"
          style={{ width: `${Math.min(100, Math.max(0, score))}%` }}
        />
      </div>
      <span className={`${s.value} font-mono font-medium text-white text-right`}>
        {score || 0}
      </span>
    </div>
  );
};

// Compact score badge for inline display
export const VettScoreBadge = ({ score, size = 'md' }) => {
  const getScoreColor = (s) => {
    if (s >= 80) return { bg: 'bg-[#4CBA84]/12', border: 'border-[#4CBA84]/25', text: 'text-[#4CBA84]' };
    if (s >= 60) return { bg: 'bg-[#5B8AF0]/12', border: 'border-[#5B8AF0]/25', text: 'text-[#5B8AF0]' };
    if (s >= 40) return { bg: 'bg-[#F0A030]/12', border: 'border-[#F0A030]/25', text: 'text-[#F0A030]' };
    return { bg: 'bg-[#707080]/12', border: 'border-[#707080]/25', text: 'text-[#707080]' };
  };

  const colors = getScoreColor(score);
  
  const sizeClasses = {
    sm: 'px-1.5 py-0.5 text-[9px]',
    md: 'px-2 py-1 text-[10px]',
    lg: 'px-2.5 py-1 text-xs'
  };

  return (
    <div 
      className={`inline-flex items-center gap-1 rounded-full ${colors.bg} ${colors.border} border ${sizeClasses[size]} font-mono`}
      data-testid="vett-score-badge"
    >
      <span className={`font-medium ${colors.text}`}>{score || 0}</span>
      <span className={`${colors.text} opacity-70`}>VETT</span>
    </div>
  );
};

export default VettScoreBar;
